import React, { Fragment, useContext, useEffect } from "react";
import { Container, Item, Segment } from "semantic-ui-react";
import NavBarDaily from "../../frontpages/dailymanagement/NavBarDaily";
import NavBarProject from "../../frontpages/projectmanagement/NavBarProject";
import NavBarHRmanagement from "../../frontpages/hrmanagement/NavBarHRmanagement";
import NavBarEmployee from "../../frontpages/technicianportal/NavBarEmployee";
import SORListDashboard from "../../frontpages/dailymanagement/sorlists/SORListDashboard";
import ProjectDashboard from "../../frontpages/projectmanagement/bdod/ProjectDashboard";
import NotFound from "./NotFound";
import { ToastContainer } from "react-toastify";
import ModalContainer from "../common/modals/ModalContainer";
import { observer } from "mobx-react-lite";
import { Route, withRouter, RouteComponentProps, Switch } from "react-router-dom";
import HomePage from "../../frontpages/home/Home";
import SORListEditForm from "../../frontpages/dailymanagement/sorlists/SORListEditForm";
import SORListDetails from "../../frontpages/dailymanagement/sorlists/SORListDetails";
import SORListCreateForm from "../../frontpages/dailymanagement/sorlists/SORListCreateForm";
import ProjectEditForm from "../../frontpages/projectmanagement/bdod/ProjectEditForm";
import ProjectDetails from "../../frontpages/projectmanagement/bdod/ProjectDetails";
import ProjectCreateForm from "../../frontpages/projectmanagement/bdod/ProjectCreateForm";
import WarehouseEditForm from "../../frontpages/dailymanagement/warehouses/WarehouseEditForm";
import WarehouseDetails from "../../frontpages/dailymanagement/warehouses/WarehouseDetails";
import WarehouseCreateForm from "../../frontpages/dailymanagement/warehouses/WarehouseCreateForm";
import WarehouseDashboard from "../../frontpages/dailymanagement/warehouses/WarehouseDashboard";
import PhotoRequestEditForm from "../../frontpages/dailymanagement/photorequests/PhotoRequestEditForm";
import PhotoRequestDetails from "../../frontpages/dailymanagement/photorequests/PhotoRequestDetails";
import PhotoRequestCreateForm from "../../frontpages/dailymanagement/photorequests/PhotoRequestCreateForm";
import PhotoRequestDashboard from "../../frontpages/dailymanagement/photorequests/PhotoRequestDashboard";
import InvoiceEditForm from "../../frontpages/dailymanagement/invoices/InvoiceEditForm";
import InvoiceDetails from "../../frontpages/dailymanagement/invoices/InvoiceDetails";
import InvoiceCreateForm from "../../frontpages/dailymanagement/invoices/InvoiceCreateForm";
import InvoiceDashboard from "../../frontpages/dailymanagement/invoices/InvoiceDashboard";
import CertificateDashboard from "../../frontpages/hrmanagement/certificates/CertificateDashboard";
import CertificateEditForm from "../../frontpages/hrmanagement/certificates/CertificateEditForm";
import CertificateDetails from "../../frontpages/hrmanagement/certificates/CertificateDetails";
import CertificateCreateForm from "../../frontpages/hrmanagement/certificates/CertificateCreateForm";
import TechnicianCertificateDashboard from "../../frontpages/hrmanagement/techniciancertificates/TechnicianCertificateDashboard";
import TechnicianCertificateEditForm from "../../frontpages/hrmanagement/techniciancertificates/TechnicianCertificateEditForm";
import TechnicianCertificateCreateForm from "../../frontpages/hrmanagement/techniciancertificates/TechnicianCertificateCreateForm";
import Thirdlist from "../../frontpages/dailymanagement/third/Thirdlist";
import Thirddetail from "../../frontpages/dailymanagement/third/Thirddetail";
import Thirdedit from "../../frontpages/dailymanagement/third/Thirdedit";
import Thirdadd from "../../frontpages/dailymanagement/third/Thirdadd";
import LoginForm from "../../frontpages/user/LoginForm";
import LoginPage from "../../frontpages/home/LoginPage";
import { RootStoreContext } from "../stores/rootStore";
import LoadingComponent from "./LoadingComponent";
import EmployeeDashboard from "../../frontpages/hrmanagement/employees/EmployeeDashboard";
import EmployeeEditForm from "../../frontpages/hrmanagement/employees/EmployeeEditForm";
import EmployeeDetails from "../../frontpages/hrmanagement/employees/EmployeeDetails";
import EmployeeCreateForm from "../../frontpages/hrmanagement/employees/EmployeeCreateForm";
import ProjectPhotoUpload from "../../frontpages/technicianportal/ProjectPhotoUpload";
import RegisterSuccess from "../../frontpages/user/RegisterSuccess";
import VerifyEmail from "../../frontpages/user/VerifyEmail";
import ResetSuccess from "../../frontpages/user/ResetSuccess";
import TechnicianProject from "../../frontpages/technicianportal/TechnicianProject";
import TechnicianSOR from "../../frontpages/technicianportal/TechnicianSOR";
import EmployeeCertificateDashboard from "../../frontpages/technicianportal/certificate/EmployeeCertificateDashboard";
import EmployeeCertificateCreateForm from "../../frontpages/technicianportal/certificate/EmployeeCertificateCreateForm";
import NavBarFinance from "../../frontpages/financemanagement/NavBarFinance";
import FttbHourDashboard from "../../frontpages/financemanagement/fttbhours/FttbHourDashboard";
import FttbHourCreateForm from "../../frontpages/financemanagement/fttbhours/FttbHourCreateForm";
import FttbHourEditForm from "../../frontpages/financemanagement/fttbhours/FttbHourEditForm";
import EmployeeFttbHourDashboard from "../../frontpages/technicianportal/fttb/EmployeeFttbHourDashboard";
import EmployeeProfileDetails from "../../frontpages/technicianportal/profile/EmployeeProfileDetails";
import EmployeeProfileEditForm from "../../frontpages/technicianportal/profile/EmployeeProfileEditForm";
import BdodJobDashboard from "../../frontpages/financemanagement/bdodjobs/BdodJobDashboard";
import BdodJobCreateForm from "../../frontpages/financemanagement/bdodjobs/BdodJobCreateForm";
import BdodJobEditForm from "../../frontpages/financemanagement/bdodjobs/BdodJobEditForm";
import EmployeeBdodJobsDashboard from "../../frontpages/technicianportal/bdod/EmployeeBdodJobsDashboard";
import UnifyJobDashboard from "../../frontpages/financemanagement/unifyjobs/UnifyJobDashboard";
import UnifyJobCreateForm from "../../frontpages/financemanagement/unifyjobs/UnifyJobCreateForm";
import UnifyJobEditForm from "../../frontpages/financemanagement/unifyjobs/UnifyJobEditForm";
import EmployeeUnifyJobDashboard from "../../frontpages/technicianportal/unifyjob/EmployeeUnifyJobDashboard";
import SiteVodafoneDashboard from "../../frontpages/projectmanagement/sitevodafones/SiteVodafoneDashboard";
import SiteVodafoneDetails from "../../frontpages/projectmanagement/sitevodafones/SiteVodafoneDetails";
import SiteVodafoneEditForm from "../../frontpages/projectmanagement/sitevodafones/SiteVodafoneEditForm";
import FttcHourDashboard from "../../frontpages/financemanagement/fttchours/FttcHourDashboard";
import FttcHourCreateForm from "../../frontpages/financemanagement/fttchours/FttcHourCreateForm";
import EmployeeFttcHourDashboard from "../../frontpages/technicianportal/fttc/EmployeeFttcHourDashboard";
import FttcHourEditForm from "../../frontpages/financemanagement/fttchours/FttcHourEditForm";
import CustomerDashboard from "../../frontpages/dailymanagement/customers/CustomerDashboard";
import CustomerDetails from "../../frontpages/dailymanagement/customers/CustomerDetails";
import CustomerEditForm from "../../frontpages/dailymanagement/customers/CustomerEditForm";
import CustomerCreateForm from "../../frontpages/dailymanagement/customers/CustomerCreateForm";
import TransmissionDashboard from "../../frontpages/projectmanagement/Transmission/TransmissionDashboard";
import TransmissionCreateForm from "../../frontpages/projectmanagement/Transmission/TransmissionCreateForm";
import TransmissionDetails from "../../frontpages/projectmanagement/Transmission/TransmissionDetails";
import TransmissionEditForm from "../../frontpages/projectmanagement/Transmission/TransmissionEditForm";
import AssetDashboard from "../../frontpages/dailymanagement/Assets/AssetDashboard";
import AssetCreateForm from "../../frontpages/dailymanagement/Assets/AssetCreateForm";
import AssetDetails from "../../frontpages/dailymanagement/Assets/AssetDetails";
import AssetEditForm from "../../frontpages/dailymanagement/Assets/AssetEditForm";
import EmployeeAssetList from "../../frontpages/technicianportal/assets/EmployeeAssetList";
import TechnicianTransmissionDashboard from "../../frontpages/technicianportal/transmission/TechnicianTransmissionDashboard";
import TechnicianTransmissionChecklistForm from "../../frontpages/technicianportal/transmission/TechnicianTransmissionChecklistForm";
import TechnicianTransmissionPhoto from "../../frontpages/technicianportal/transmission/TechnicianTransmissionPhoto";
import SideBar from "../../frontpages/home/SideBar";
import HRDashboard from "../../frontpages/hrmanagement/HRDashboard";
import MobileDashboard from "../../frontpages/projectmanagement/mobile/MobileDashboard";
import MobileDetails from "../../frontpages/projectmanagement/mobile/MobileDetails";
import MobileCreateForm from "../../frontpages/projectmanagement/mobile/MobileCreateForm";
import MobileEditForm from "../../frontpages/projectmanagement/mobile/MobileEditForm";
import ProjectManagementDashboard from "../../frontpages/projectmanagement/ProjectManagementDashboard";
import EmployeeSiteVodafoneDashboard from "../../frontpages/technicianportal/sitevodafones/EmployeeSiteVodafoneDashboard";
import EmployeeSiteVodafoneDetails from "../../frontpages/technicianportal/sitevodafones/EmployeeSiteVodafoneDetails";
import EmployeeSiteVodafoneEditForm from "../../frontpages/technicianportal/sitevodafones/EmployeeSiteVodafoneEditForm";
import MinorDashboard from "../../frontpages/projectmanagement/minor/MinorDashboard";
import MinorDetails from "../../frontpages/projectmanagement/minor/MinorDetails";
import MinorCreateForm from "../../frontpages/projectmanagement/minor/MinorCreateForm";
import MinorEditForm from "../../frontpages/projectmanagement/minor/MinorEditForm";
import EmployeeTimeSheetForm from "../../frontpages/technicianportal/timesheets/EmployeeTimeSheetForm";
import TimeSheetPayForm from "../../frontpages/financemanagement/timesheets/TimeSheetPayForm";
import TimeSheetApproveForm from "../../frontpages/hrmanagement/timesheets/TimeSheetApproveForm";
import JobPositionDashboard from "../../frontpages/hrmanagement/jobpositions/JobPositionDashboard";
import JobPositionCreateForm from "../../frontpages/hrmanagement/jobpositions/JobPositionCreateForm";
import JobPositionEditForm from "../../frontpages/hrmanagement/jobpositions/JobPositionEditForm";
import BogDashboard from "../../frontpages/hrmanagement/bogs/BogDashboard";
import ProjectTimeDashboard from "../../frontpages/hrmanagement/projecttimes/ProjectTimeDashboard";
import ProjectTimeCreateForm from "../../frontpages/hrmanagement/projecttimes/ProjectTimeCreateForm";
import ProjectTimeEditForm from "../../frontpages/hrmanagement/projecttimes/ProjectTimeEditForm";
import TimeSheetDashboard from "../../frontpages/hrmanagement/timesheets/TimeSheetDashboard";
import { history } from '../..';


const App: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const { setAppLoaded, token, appLoaded } = rootStore.commonStore;
  const { getUser, user } = rootStore.userStore;

  useEffect(() => {
    if (token) {
      getUser().finally(() => setAppLoaded())
    } else {
      setAppLoaded();
      history.push('/');
    }
  }, [getUser, setAppLoaded, token])

  if (!appLoaded) return <LoadingComponent content='Loading app...' />

  return (
    <Fragment>
      <ModalContainer />
      <ToastContainer position='top-center' />
      <Route exact path='/' component={LoginPage} />
      <Route path='/login' component={LoginForm} />
      <Route path='/user/registerSuccess' component={RegisterSuccess} />
      <Route path='/user/verifyEmail' component={VerifyEmail} />
      <Route path='/user/resetSuccess' component={ResetSuccess} />
      {  (user) && (user.role === 'Admin' || user.role === 'Accountant' || user.role === 'Super')  &&
       <Route exact path='/home' component={HomePage} />}
      <Route
        // path={'/(.+)'}
        path={'/dailymanagement'}
        render={() => (user) && (user.role === 'Admin' || user.role === 'Accountant' || user.role === 'Super') && (
          <Fragment>
            <SideBar />
            <NavBarDaily />
            <Container style={{ marginTop: '6em' }}>
            <Switch>
              <Route exact path='/dailymanagement/sorlist' component={SORListDashboard} />
              <Route path='/dailymanagement/sorlist/:id' component={SORListDetails} />
              <Route path='/dailymanagement/sorlist-create' component={SORListCreateForm} />
              <Route path='/dailymanagement/sorlist-edit/:id' component={SORListEditForm} />

              <Route exact path='/dailymanagement/warehouse' component={WarehouseDashboard} />
              <Route path='/dailymanagement/warehouse/:id' component={WarehouseDetails} />
              <Route path='/dailymanagement/warehouse-create' component={WarehouseCreateForm} />
              <Route path='/dailymanagement/warehouse-edit/:id' component={WarehouseEditForm} />

              <Route exact path='/dailymanagement/invoice' component={InvoiceDashboard} />
              <Route path='/dailymanagement/invoice/:id' component={InvoiceDetails} />
              <Route path='/dailymanagement/invoice-create' component={InvoiceCreateForm} />
              <Route path='/dailymanagement/invoice-edit/:id' component={InvoiceEditForm} />

              <Route exact path='/dailymanagement/third' component={Thirdlist} />
              <Route path='/dailymanagement/third/:name' component={Thirddetail} />
              <Route path='/dailymanagement/third-edit/:name' component={Thirdedit} />
              <Route path='/dailymanagement/thirdAdd/' component={Thirdadd} />

              <Route exact path='/dailymanagement/photorequest' component={PhotoRequestDashboard} />
              <Route path='/dailymanagement/photorequest/:id' component={PhotoRequestDetails} />
              <Route path='/dailymanagement/photorequest-create' component={PhotoRequestCreateForm} />
              <Route path='/dailymanagement/photorequest-edit/:id' component={PhotoRequestEditForm} />

              <Route exact path='/dailymanagement/customer' component={CustomerDashboard} />
              <Route path='/dailymanagement/customer/:id' component={CustomerDetails} />
              <Route path='/dailymanagement/customer-edit/:id' component={CustomerEditForm} />
              <Route path='/dailymanagement/customer-create/' component={CustomerCreateForm} />
             </Switch>

              <Route exact path='/dailymanagement/asset' component={AssetDashboard} />
              <Route path='/dailymanagement/asset/:id' component={AssetDetails} />
              <Route path='/dailymanagement/asset-edit/:id' component={AssetEditForm} />
              <Route path='/dailymanagement/asset-create/' component={AssetCreateForm} />
             
            </Container>
          </Fragment>
        )}
      />

      <Route
        // path={'/(.+)'}
        path={'/hrmanagement'}
        render={() => (user) && (user.role === 'Admin' || user.role === 'Accountant' || user.role === 'Super') && (
          <Fragment>
            <SideBar />
            <NavBarHRmanagement />
            <Item  style={{ marginTop: '4rem', marginLeft: "12%" }} >
              <Switch>
              <Route exact path='/hrmanagement' component={HRDashboard} />

              <Route exact path='/hrmanagement/certificate' component={CertificateDashboard} />
              <Route path='/hrmanagement/certificate/:id' component={CertificateDetails} />
              <Route path='/hrmanagement/certificate-create' component={CertificateCreateForm} />
              <Route path='/hrmanagement/certificate-edit/:id' component={CertificateEditForm} />

              <Route exact path={['/hrmanagement/techniciancertificate/dashboard/:expiry',
              '/hrmanagement/techniciancertificate/dashboard']} component={TechnicianCertificateDashboard} />
              <Route path='/hrmanagement/techniciancertificate-create/:email' component={TechnicianCertificateCreateForm} />
              <Route path='/hrmanagement/techniciancertificate-edit/:id' component={TechnicianCertificateEditForm} />

              <Route exact path='/hrmanagement/employees' component={EmployeeDashboard} />
              <Route path='/hrmanagement/employees/:id' component={EmployeeDetails} />
              <Route path='/hrmanagement/employees-create' component={EmployeeCreateForm} />
              <Route path='/hrmanagement/employees-edit/:id' component={EmployeeEditForm} />

              {  (user) && (user.role === 'Admin' || user.role === 'Accountant')  &&
                <Route exact path='/hrmanagement/timesheets' component={TimeSheetDashboard} />}
              {  (user) && (user.role === 'Super')  &&
                <Route exact path='/hrmanagement/timesheets' component={TimeSheetApproveForm} />}
              
              <Route exact path='/hrmanagement/bogs' component={BogDashboard} />
              
              <Route exact path='/hrmanagement/jobposition' component={JobPositionDashboard} />
              <Route path='/hrmanagement/jobposition-create' component={JobPositionCreateForm} />
              <Route path='/hrmanagement/jobposition-edit/:id' component={JobPositionEditForm} />

              <Route exact path='/hrmanagement/projecttimes' component={ProjectTimeDashboard} />
              <Route path='/hrmanagement/projecttimes-create' component={ProjectTimeCreateForm} />
              <Route path='/hrmanagement/projecttimes-edit/:id' component={ProjectTimeEditForm} />
              </Switch>
            </Item>
          </Fragment>
        )}
      />

      <Route
        // path={'/(.+)'}
        path={'/projectmanagement'}
        render={() => (user) && (user.role === 'Admin' || user.role === 'Accountant' || user.role === 'Super') && (
          <Fragment>
            <SideBar />
            <NavBarProject />
            <Item  style={{ marginTop: '4rem', marginLeft: "12%" }} >
            <Switch>
              <Route exact path='/projectmanagement' component={ProjectManagementDashboard} />
              <Route exact path='/projectmanagement/project' component={ProjectDashboard} />
              <Route path='/projectmanagement/project/:id' component={ProjectDetails} />
              <Route path='/projectmanagement/project-create' component={ProjectCreateForm} />
              <Route path='/projectmanagement/project-edit/:id' component={ProjectEditForm} />

              <Route exact path='/projectmanagement/sitevodafone' component={SiteVodafoneDashboard} />
              <Route path='/projectmanagement/sitevodafone/:id' component={SiteVodafoneDetails} />
              <Route path='/projectmanagement/sitevodafone-edit/:id' component={SiteVodafoneEditForm} />

              <Route exact path='/projectmanagement/transmission' component={TransmissionDashboard} />
              <Route path='/projectmanagement/transmission/:id' component={TransmissionDetails} />
              <Route path='/projectmanagement/transmission-create' component={TransmissionCreateForm} />
              <Route path='/projectmanagement/transmission-edit/:id' component={TransmissionEditForm} />

              <Route exact path='/projectmanagement/mobile' component={MobileDashboard} />
              <Route path='/projectmanagement/mobile/:id' component={MobileDetails} />
              <Route path='/projectmanagement/mobile-create' component={MobileCreateForm} />
              <Route path='/projectmanagement/mobile-edit/:id' component={MobileEditForm} />

              <Route exact path='/projectmanagement/minor' component={MinorDashboard} />
              <Route path='/projectmanagement/minor/:id' component={MinorDetails} />
              <Route path='/projectmanagement/minor-create' component={MinorCreateForm} />
              <Route path='/projectmanagement/minor-edit/:id' component={MinorEditForm} />
              </Switch>
            </Item>
          </Fragment>
        )}
      />

      <Route
        // path={'/(.+)'}
        path={'/employeeportal'}
        render={() => (user) && (
          <Fragment>
            <NavBarEmployee />
            <Item style={{ marginTop: '4em' }}>
              <Switch>
              <Route exact path='/employeeportal/photoupload/:id' component={ProjectPhotoUpload} />
              <Route exact path='/employeeportal/technicianproject' component={TechnicianProject} />
              <Route exact path='/employeeportal/techniciansor/:id' component={TechnicianSOR} />
              <Route exact path='/employeeportal/certificate' component={EmployeeCertificateDashboard} />
              <Route exact path='/employeeportal/certificate-create' component={EmployeeCertificateCreateForm} />
              <Route exact path='/employeeportal/fttbhour' component={EmployeeFttbHourDashboard} />
              <Route exact path='/employeeportal/profile' component={EmployeeProfileDetails} />
              <Route exact path='/employeeportal/profile-edit' component={EmployeeProfileEditForm} />
              <Route exact path='/employeeportal/bdodjobs' component={EmployeeBdodJobsDashboard} />
              <Route exact path='/employeeportal/unifyjob' component={EmployeeUnifyJobDashboard} />
              <Route exact path='/employeeportal/fttchour' component={EmployeeFttcHourDashboard} />
              <Route exact path='/employeeportal/assets' component={EmployeeAssetList} />
              <Route exact path='/employeeportal/techniciantransmission' component={TechnicianTransmissionDashboard} />
              <Route exact path='/employeeportal/techniciantransmission-edit/:id' component={TechnicianTransmissionChecklistForm} />
              <Route exact path='/employeeportal/techniciantransmission-photo/:id' component={TechnicianTransmissionPhoto} />

              <Route exact path='/employeeportal/sitevodafone' component={EmployeeSiteVodafoneDashboard} />
              <Route path='/employeeportal/sitevodafone/:id' component={EmployeeSiteVodafoneDetails} />
              <Route path='/employeeportal/sitevodafone-edit/:id' component={EmployeeSiteVodafoneEditForm} />

              <Route exact path='/employeeportal/timesheet' component={EmployeeTimeSheetForm} />
              </Switch>
            </Item>
          </Fragment>
        )}
      />

        <Route
        // path={'/(.+)'}
        path={'/financemanagement'}
        render={() => (user) && (user.role === 'Super' || user.role === 'Accountant') && (
          <Fragment>
            <SideBar />
            <NavBarFinance />
            <Container style={{ marginTop: '6em' }}>
            <Switch>
              <Route exact path='/financemanagement/fttbhour' component={FttbHourDashboard} />
              <Route path='/financemanagement/fttbhour-create' component={FttbHourCreateForm} />
              <Route path='/financemanagement/fttbhour-edit/:id' component={FttbHourEditForm} />

              <Route exact path='/financemanagement/bdodjob' component={BdodJobDashboard} />
              <Route path='/financemanagement/bdodjob-create' component={BdodJobCreateForm} />
              <Route path='/financemanagement/bdodjob-edit/:id' component={BdodJobEditForm} />

              <Route exact path='/financemanagement/unifyjob' component={UnifyJobDashboard} />
              <Route path='/financemanagement/unifyjob-create' component={UnifyJobCreateForm} />
              <Route path='/financemanagement/unifyjob-edit/:id' component={UnifyJobEditForm} />

              <Route exact path='/financemanagement/fttchour' component={FttcHourDashboard} />
              <Route path='/financemanagement/fttchour-create' component={FttcHourCreateForm} />
              <Route path='/financemanagement/fttchour-edit/:id' component={FttcHourEditForm} />

              <Route exact path='/financemanagement/timesheetpay' component={TimeSheetPayForm} />
              </Switch>
            </Container>
          </Fragment>
        )}
      />

    </Fragment>
  );
};

export default withRouter(observer(App));
